export const serviceCredentials = {};

export const registerClientHiddenFields = {
  // pais: 0, // consultaClienteMis nacionalidad
  // venezolano: "true", // evaluar con document id
  calificacion: 0, // enviar como 0
  ciiu: "", // enviar empty string
  codigoMis: 0,
  codMalRef: 0, // enviar como 0
  codigoSicri: 0, // enviar como 0
  comentarios: "", // enviar empty string
  direccion: "", // enviar empty string
  empleado: 0, // enviar como 0
  esOficinaBangente: 0, // enviar como 0
  fax: 0, // enviar como 0
  // fechaDesde: "", // enviar empty string
  fechaUltimaModificacion: "2022-04-05T12:31:09-04:30", // enviar empty string
  fuenteOrigen: 0, // enviar como 0
  grupoEconomico: 0, // enviar como 0
  lenguaje: 0, // enviar como 0
  lineaCredito: 0, // enviar como 0
  // mail: "", // enviar empty string
  // oficina: "208", // oficina de form
  patrimonioTecnico: 0, // enviar como 0
  referencia: 0, // enviar como 0
  referenciaBancaria: 0, // enviar como 0
  riskCodPais: 0, // enviar como 0
  sectorEconomico: 0, // enviar como 0
  seguridad: "N", // enviar como N
  territorio: 0, // enviar como 0
  tipoPersona: "N", // enviar como N
  vinculacion: 0, // enviar como 0
  // oficinaAsesor: 147, // enviar como 147
};

export const registerClientDirectionHiddenFields = {
  avenida: "",
  casa: "",
  centroComercial: "",
  codDireccion: 0,
//   codigoMIS: 0,
  conjunto: "",
  descDireccion: "",
  edificio: "",
  email: "",
  esquina: "",
  funcionario: "",
  identificador: 0,
  local: "",
  oficina: "",
  oficinaBanco: "",
  principal: "",
// desabilitar tipo domicilio en redes sociales,
// enviar valor en param de email todos
//   ptoReferencia: 0,
  quinta: "",
  residencia: "",
  rutaCartero: "",
  telefono3: {
    codigoArea: "000",
    descripcionTipoDireccion: 0,
    identificador: 3,
    numero: "0000000",
    tipo: "C",
    tipoDireccion: "D",
  },
  tipo: "D",
  tipoCalle: "",
  verificado: "S",
  vigente: "S",
  web: "",
  zona: "",
};

export const consultClientHiddenFields = {
  canal: 1,
  oficina: 147,
  codigoMis: 0,
  filas: 0,
  nombre: "",
  parcial: "false",
  primerApellido: "",
  segundoApellido: "",
  subTipoOperacion: "P",
  modo: 1,
  tipoOperacion: 1,
  oficinaAsesor: 307
}

export const consultClientAddressesFields = {
  canal:1,
  operacion:"A",
  oficina: 800,
  oficinaAsesor:165,
}

export const updateClientHiddenFields = {
  calificacion: 0,
  codMalRef: 0,
  comentarios: "",
  direccion: "",
  fechaUltimaModificacion: "2024-09-25T15:01:17+02:00",
  grupoEconomico: 0,
  fuenteOrigen: 0,
  lenguaje: 0,
  lineaCredito: 0,
  territorio: 0,
  seguridad: "N",
  tipoCliente: "N",
  tipoPersona: "N",
  vinculacion: 0,
  patrimonioTecnico: 0,
  referencia: 0,
  referenciaBancaria: 0,
}

export const insertAddressHiddenFields = {
  apartamento: "",
  avenida: "",
  calle: "",
  casa: "",
  centroComercial: "",
  ciudad: 0,
  codDireccion: 0,
  codigoMIS: 0,
  conjunto: "",
  descDireccion: "",
  edificio: "",
  email: "",
  entidad: 0,
  esquina: "",
  funcionario: "",
  identificador: 0,
  inmueble: "",
  local: "",
  municipio: 0,
  nivel: "",
  oficina: "",
  oficinaBanco: 165,
  pais: 0,
  parroquia: 0,
  piso: "",
  principal: 0,
  quinta: "",
  residencia: "",
  rutaCartero: "",
  telefono1: {
    codigoArea: 0,
    descripcionTipoDireccion: 0,
    identificador: 1,
    numero: 0,
    tipo: "T",
    tipoDireccion: 0
  },
  telefono2: {
    codigoArea: 0,
    descripcionTipoDireccion: 0,
    identificador: 2,
    numero: 0,
    tipo: "T",
    tipoDireccion: 0
  },
  telefono3: {
    codigoArea: 0,
    descripcionTipoDireccion: 0,
    identificador: 3,
    numero: 0,
    tipo: "T",
    tipoDireccion: 0
  },
  facebook: "",
  twitter: "",
  instagram: "",
  tipo: "D",
  tipoCalle: "",
  tipoDireccion: "D",
  tipoInmueble: "",
  torre: "",
  urbanizacion: 0,
  verificado: "S",
  vigente: "S",
  ptoReferencia: "",
  web: "",
  zona: ""
}